import styled from 'styled-components';

export const TeamContainer = styled.div`
  width: 100%;
`;

export const TeamHero = styled.section`
  background: linear-gradient(rgba(34, 139, 34, 0.8), rgba(34, 139, 34, 0.8)),
              url('/team-hero.jpg') center/cover;
  padding: 100px 0;
  color: white;
  text-align: center;
`;

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const PageTitle = styled.h1`
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

export const PageSubtitle = styled.p`
  font-size: 1.3rem;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
`;

export const TeamContent = styled.section`
  padding: 80px 0;
  background: #f8f9fa;
`;

export const TeamGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-bottom: 80px;
`;

export const TeamCard = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  text-align: center;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
  }
`;

export const MemberImage = styled.div`
  height: 250px;
  background: linear-gradient(135deg, #228B22 0%, #32CD32 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 4rem;
  position: relative;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const MemberContent = styled.div`
  padding: 30px;
`;

export const MemberName = styled.h3`
  font-size: 1.4rem;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
`;

export const MemberRole = styled.p`
  color: #228B22;
  font-weight: 500;
  margin-bottom: 15px;
  font-size: 1rem;
`;

export const MemberBio = styled.p`
  color: #666;
  line-height: 1.6;
  font-size: 0.95rem;
  margin-bottom: 20px;
`;

export const MemberContact = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
`;

export const ContactLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  background: #f8f9fa;
  border-radius: 50%;
  color: #228B22;
  text-decoration: none;
  transition: all 0.3s ease;
  
  &:hover {
    background: #228B22;
    color: white;
    transform: translateY(-2px);
  }
  
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const SectionTitle = styled.h2`
  text-align: center;
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 20px;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 60px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
`;

export const JoinTeamSection = styled.section`
  background: linear-gradient(135deg, #228B22 0%, #32CD32 100%);
  color: white;
  padding: 80px 0;
  text-align: center;
`;

export const JoinTeamTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight: 700;
  
  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const JoinTeamText = styled.p`
  font-size: 1.2rem;
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;
`;

export const JoinTeamButton = styled.button`
  background: white;
  color: #228B22;
  border: none;
  padding: 15px 30px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(255, 255, 255, 0.3);
  }
`;
